import axios from "axios";
import React, { createContext, useState, ReactNode, useEffect, useContext } from "react";
import ReactDOM from 'react-dom';
import Lottie from 'lottie-react';

import WarningAnimation from "assets/images/WarningAnimation.json";
import { showGlobalModal } from "components/GlobalModal";

interface Country {
  COUNTRY_NAME: string;
  COUNTRY_CODE: string;
}

interface DropDownOptions {
  value: string;
  label: string;
}
interface Avatar {
  value: string;
  label: string;
  type: "default";
  image: string;
  video: string;
}
interface IvrLanguages {
  // LANGUAGE_ID: string;
  // NAME: string;
  // STATUS: string;
  value: string;
  label: string;
}

interface InstitutionData {
  countries: Country[];
  Instruction_Medium: DropDownOptions[];
  InstitutionType: DropDownOptions[];
  GradeLevels: DropDownOptions[];
  BoardType: DropDownOptions[];
  AddonPrograms: DropDownOptions[];
  InstituteImageTitles: DropDownOptions[];
  MaterialType: DropDownOptions[];
  SubjectOptions: DropDownOptions[];
  Avatars: Avatar[];
  IvrLanguages: IvrLanguages[];
}

// Define the type for the context
interface AppContextType {
  globalData: InstitutionData;
  formChanged: boolean;
  setFormChanged: any;
  instData: any;
  setInstData: any;
  // setGlobalData: React.Dispatch<React.SetStateAction<object>>;
}

const defaultData = {
  countries: [],
  Instruction_Medium: [],
  InstitutionType: [],
  GradeLevels: [],
  BoardType: [],
  AddonPrograms: [],
  InstituteImageTitles: [],
  MaterialType: [],
  SubjectOptions: [],
  Avatars: [],
  IvrLanguages: [],
};

// Create the context with default values
export const AppContext = createContext<AppContextType | undefined>(undefined);

// Provider component
export const AppProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [globalData, setGlobalData] = useState<InstitutionData>(defaultData);

  const [formChanged, setFormChanged] = useState<boolean>(() => {
    return JSON.parse(sessionStorage.getItem('formChanged') || 'false');
  });

  const [instData, setInstData] = useState<any>(() => {
    return JSON.parse(sessionStorage.getItem('_DATA_') || "{}");
  });

  const [showModal, setShowModal] = useState(false);
  const [isLeaving, setIsLeaving] = useState(false);

  // Handle unsaved changes
  // useEffect(() => {
  //   const handleBeforeUnload = (e) => {
  //     if (formChanged && !isLeaving) {
  //       e.preventDefault();
  //       e.returnValue = ''; // Required for Chrome
  //       setShowModal(showModal => true);
  //       return '';
  //     }
  //   };

  //   window.addEventListener('beforeunload', handleBeforeUnload);

  //   return () => {
  //     window.removeEventListener('beforeunload', handleBeforeUnload);
  //   };
  // }, [formChanged, isLeaving]);

    // // Optional: Show modal on tab change
  // useEffect(() => {
  //   const handleVisibilityChange = () => {
  //     if (document.visibilityState === 'hidden' && formChanged) {
  //       setShowModal(showModal => true);
  //     }
  //   };

  //   document.addEventListener('visibilitychange', handleVisibilityChange);

  //   return () => {
  //     document.removeEventListener('visibilitychange', handleVisibilityChange);
  //   };
  // }, [formChanged]);

  // const handleStay = () => {
  //   setShowModal(false);
  // };

  // const handleLeave = async () => {
  //   try {
  //     const response = await axios.post(
  //       "https://dev.soomuch.ai/api/v1/master/rollback/institute", { database_name: instData?.DATABASE_NAME }
  //     );
  //     sessionStorage.clear();
  //     setFormChanged(formChanged => false);
  //     setIsLeaving(isLeaving => true);
  //     setShowModal(showModal => false);
  //     window.close();
  //     // window.location.href = 'about:blank'; // Or any redirect
  //   } catch (err) {
  //     showGlobalModal(err.message, "error");

  //   }
  // };


  const fetchMetaData = async () => {
    try {
      const response = await axios.get(
        `https://dev.soomuch.ai/api/v1/master/onboarding/metadata`
      );
      if (response?.data?.data) {
        const transformedData = Object.fromEntries(
          Object.entries(response?.data?.data).map(([key, value]) => {
            if (["countries"/* , "ivrlanguages" */].includes(key?.toLowerCase())) return [key, value]; // Keep countries as is
            return [
              key,
              (value as any)?.map((item) => ({ value: item, label: item })),
            ];
          })
        );
        setGlobalData((globalData) => transformedData as any);
      }
    } catch (err) {
      setGlobalData((globalData) => defaultData);
    }
  };

  useEffect(() => {
    fetchMetaData();
  }, []);

  useEffect(() => {
    sessionStorage.setItem('formChanged', JSON.stringify(formChanged));
  }, [formChanged]);

  useEffect(() => {
    if(!!instData?.BRANCH_ID) {
      sessionStorage.setItem('_DATA_', JSON.stringify(instData));
    }
  }, [instData?.BRANCH_ID]);

  return (
    <AppContext.Provider value={{ formChanged, setFormChanged, globalData, setInstData, instData }}>
      {children}
      {/* {!!showModal && ReactDOM.createPortal(
        <div style={modalStyles.overlay as any}>
          <div className='max-w-md w-full m-auto bg-[white] rounded-3xl p-6 shadow-lg outline-none'>
            <div className='flex flex-col items-center px-6 gap-2'>
              <Lottie animationData={WarningAnimation} loop={false} className='h-28' />
              <p className="text-center font-manropeEB text-[4vh]">Wait! Don’t got yet!</p>
              <p className='text-center font-manrope text-[2.6vh]'>
                You have unsaved changes. Are you sure you want to leave?
              </p>
              <div className='flex gap-4 mt-4'>
                <button onClick={handleStay} className='inline-flex items-center px-[3.5vh] py-[2vh] text-[2.4vh] font-medium text-center text-[white] bg-blue-700 rounded-xl hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 focus:outline-none'>
                  Stay Here
                </button>
                <button type="button" onClick={handleLeave} className="px-[3.5vh] py-[2vh] text-[2.4vh] font-medium text-gray-900 bg-[white] border border-gray-300 rounded-xl focus:outline-none hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100">
                  Leave Anyway
                </button>
              </div>
            </div>
          </div>
        </div>,
        document.getElementById('root')
      )} */}
    </AppContext.Provider>
  );
};

export const useGlobalState = () => useContext(AppContext);


const modalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
  },
};
